export default "__VITE_ASSET__Da_03pBD__"